
<template>
	<page>
		<module>
            <view-list
                    ref="view"
                    work-type="40"
                    selector
            >
				<template #search>
					<m-search ref="search">
						<m-search-item label="场次">
							<c-input name="auction_batch_no"></c-input>
						</m-search-item>
						<m-search-item label="报告时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<!--导出不做按钮级权限控制：能看到本菜单即可导出-->
				<template #operate>
					<c-button prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<!--选中态 operate 槽被批量条替换，导出入口须在此复放（同客户/供应商列表先例）；勾选后仅导出选中行-->
				<template #batchOperate="{data}">
					<c-button prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<!-- 推送渠道列：渠道名(成功/失败/未推送/总数)，台数按机器×渠道去重，成功绿、失败红、未推送灰 -->
				<template #channel_summary_json="{data}">
					<span v-for="(item, index) in parseSummary(data.channel_summary_json)" :key="index" class="m-channel-item">
						<span>{{item.channel_name}}(</span><span style="color: #19be6b;">{{item.success}}</span><span style="color: #ed3f14;">/{{item.fail}}</span><span style="color: #999;">/{{item.wait_push || 0}}</span><span>/{{item.total}})</span>
					</span>
					<span v-if="!parseSummary(data.channel_summary_json).length">-</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="160"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button icon="tf-detail" @click="viewDetail(data)">详情</c-table-button>
						<c-table-button icon="tf-export" @click="exportDetail(data)">导出明细</c-table-button>
					</template>
				</c-table-column>
			</view-list>

			<!-- 推送报告详情 -->
			<auction-push-report-detail ref="detail"></auction-push-report-detail>
		</module>
	</page>
</template>

<script>
	import AuctionPushReportDetail from './auction_push_report_detail';

	export default {
		components: {
			AuctionPushReportDetail
		},

		methods: {
			/*********解析渠道汇总JSON**********/
			parseSummary(json) {
				try {
					var list = JSON.parse(json || '[]');
					return Array.isArray(list) ? list : [];
				} catch (e) {
					return [];
				}
			},

			/*********查看推送报告详情**********/
			viewDetail(data) {
				this.$refs.detail.open({
					id: data.id
				});
			},

			/*********按场次导出推送明细（与详情弹窗同源：渠道汇总+推送明细两个sheet）**********/
			exportDetail(data) {
				this.request({
					url: '/sale/auction/report/push/detail/export/url',
					data: {
						id: data.id
					},
					loading: true,
					success: res => {
						if (res && res.url) {
							this.download({
								fileName: res.filename,
								url: res.url,
								loading: {
									message: '正在导出推送明细...'
								}
							});
						}
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-channel-item {
		display: inline-block;
		margin-right: 8px;
	}
</style>
